// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import {
  CreateUpdateTimeRecord,
  TimeRecordResponse,
  timeRecordResponseSchema,
} from '@/costs/api/types';
import { serializeOptionalCurrencyForAPI } from '@/currency/utilities/serialize';
import { serializeDateForAPI } from '@/utilities/date-time';

/**
 * Updates an existing time record using the time record endpoint.
 *
 * @param recordKey - The key of the time record to update
 * @param params - The time record update parameters
 */
export async function updateTimeRecord(
  recordKey: string,
  params: CreateUpdateTimeRecord
): Promise<TimeRecordResponse> {
  const url = `/v1/time-record/${recordKey}`;
  const response = await api.patch(url, {
    ...params,
    incurredOn: serializeDateForAPI(params.incurredOn),
    hourlyRate: serializeOptionalCurrencyForAPI(params.hourlyRate),
  });

  return parseResponse(timeRecordResponseSchema, response.data, {
    schemaName: 'UpdateTimeRecord',
    endpoint: url,
  });
}
